var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 40",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      overflow: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "pin",
    style: {
      vectorEffect: "non-scaling-stroke",
      fill: "currentcolor",
      fillOpacity: 1
    },
    d: "M 15,0.4858265 A 14.514174,14.635655 0 0 0 0.48582649,15.121482 14.514174,14.635655 0 0 0 3.3886613,23.902875 L 15,39.51424 26.611339,23.902875 A 14.514174,14.635655 0 0 0 29.514174,15.121482 14.514174,14.635655 0 0 0 15,0.4858265 Z M 15,10.24293 A 4.8380579,4.8785517 0 0 1 19.838058,15.121482 4.8380579,4.8785517 0 0 1 15,20.000034 4.8380579,4.8785517 0 0 1 10.161942,15.121482 4.8380579,4.8785517 0 0 1 15,10.24293 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "shade",
    style: {
      display: "inline",
      opacity: 0.15,
      mixBlendMode: "darken",
      vectorEffect: "non-scaling-stroke",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.666666,
      strokeDasharray: "none",
      strokeOpacity: 1,
      InkscapeStroke: "hairline"
    },
    d: "M 15,5.3643781 A 9.6761158,9.7571033 0 0 0 5.3238845,15.121482 9.6761158,9.7571033 0 0 0 15,24.878585 9.6761158,9.7571033 0 0 0 24.676116,15.121482 9.6761158,9.7571033 0 0 0 15,5.3643781 Z M 15,10.24293 A 4.8380579,4.8785517 0 0 1 19.838058,15.121482 4.8380579,4.8785517 0 0 1 15,20.000034 4.8380579,4.8785517 0 0 1 10.161942,15.121482 4.8380579,4.8785517 0 0 1 15,10.24293 Z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.a5e79df81ef5e0c20675047d1967279d.svg";
export { ForwardRef as ReactComponent };